module.exports = __webpack_public_path__ + "img/logo-new.d841f70c.svg";